// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__253yB","rootNoMargin":"styles_rootNoMargin__36XB1"};